import React, { PureComponent } from 'react';
import './css/style.css';
import Banner from './img/Banner_lp.png';
import Footer from './img/footer_lp.svg';
import Slider from 'react-slick';
import { 
    beauty_and_fashion,
    educations,
    fan_db,
    fitness,
    home_improvement,
    leisure
} from './data/benefit';


class Owner extends PureComponent {
    
    render() {
       return (
           <div class="hero_container">
               {/* <!-- Hero Section Start --> */}
               
                <div class="contianer-fluid hero_container">
                    <img src={Banner} class="img-responsive" alt="Hero" />
                </div>
        
                <div class="contianer-fluid tandc_container">
                    <div class="container">
                        <div class="row">
                            <div class="col-xs-12 col-ms-12 col-md-6 col-lg-6">
                                <h4 className="header-benefit">Terms and Conditions</h4>
                                <ul>
                                    <li className="description">The cardholder must agree City Loft's terms and conditions.</li> 
                                    <li className="description">This card is issued by and remains the property of City Loft and can only be used in designated shops. </li>
                                    <li className="description">Specified fines will be charge for any loss or damage to this card. </li>
                                    <li className="description">City Loft reserves the right to terminate the use of this Card or change the applicable terms and conditions at any time.</li> 
                                    <li className="description">City Loft shall have the final decision regarding the interpretation of these terms and conditions. </li>
                                </ul>
                            </div>
                            
                            <div class="col-xs-12 col-ms-12 col-md-6 col-lg-6">
                                <div class="row">
                                    <h4 className="header-benefit">Eligibility Criteria</h4>
                                    <ul className="val_line_container">
                                        <li className="description">Have purchased one or more units at City Loft</li> 
                                        <li className="description">Have paid 10% down payment and signed S&P</li>
                                        <li className="description">For Mortgage buyers, have signed Mortage T&C with associated bank</li>
                                    </ul>
                                </div>
                            </div>
                            
                            {/* <div class="col-xs-12 col-ms-12 col-md-6 col-lg-6">
                                <h4 className="header-benefit">Eligibility Criteria</h4>
                                <ul>
                                    <li className="description">Have purchased one or more units at City Loft</li> 
                                    <li className="description">Have paid 10% down payment and signed S&P</li>
                                    <li className="description">For Mortgage buyers, have signed Mortage T&C with associated bank</li>
                                </ul>
                            </div> */}
                        </div>
                    </div>
	            </div>
                {/* Benefit section start */}
                <div class="contianer-fluid benefits_container">
                    <div class="container">
                        <div class="row">
                            <div class="col-xs-12 col-ms-12 col-md-12 col-lg-12">
                                <h4 className="header-benefit">Card Benefits</h4><br/>
                                <div>
                                    <ul class="lp_benefits_pills nav nav-tabs" role="tablist">
                                        <li role="presentation" class="active"><a href="#beauty" aria-controls="beauty" role="tab" data-toggle="tab">Beauty & Fashion</a></li>
                                        <li role="presentation"><a href="#education" aria-controls="education" role="tab" data-toggle="tab">Education</a></li>
                                        <li role="presentation"><a href="#fandb" aria-controls="fandb" role="tab" data-toggle="tab">F&B & Entertainment</a></li>
                                        <li role="presentation"><a href="#fitness" aria-controls="fitness" role="tab" data-toggle="tab">Fitness & Health Care</a></li>
                                        <li role="presentation"><a href="#homeimprovement" aria-controls="homeimprovement" role="tab" data-toggle="tab">Home Improvement</a></li>
                                        <li role="presentation"><a href="#leisure" aria-controls="leisure" role="tab" data-toggle="tab">Leisure & Travel</a></li>
                                    </ul>
                                    <div class="tab-content">
                                        <div role="tabpanel" class="tab-pane active" id="beauty">
                                            {
                                                this.renderBenefitCarousel({data: beauty_and_fashion, is_more_two: true})
                                            }
                                        </div>

                                        <div class="clearfix"></div>
                                        <div role="tabpanel" class="tab-pane" id="education">
                                            {
                                                this.renderBenefitCarousel({data: educations, is_more_two: false})
                                            }
                                        </div>

                                        <div class="clearfix"></div>
                                        <div role="tabpanel" class="tab-pane" id="fandb">
                                            {
                                                this.renderBenefitCarousel({data: fan_db, is_more_two: true})
                                            }
                                        </div>

                                        <div class="clearfix"></div>
							            <div role="tabpanel" class="tab-pane" id="fitness">
                                            {
                                                this.renderBenefitCarousel({data: fitness, is_more_two: true})
                                            }
                                        </div>

                                        <div class="clearfix"></div>
							            <div role="tabpanel" class="tab-pane" id="homeimprovement">
                                            {
                                                this.renderBenefitCarousel({data: home_improvement, is_more_two: true})
                                            }
                                        </div>

                                        <div class="clearfix"></div>
							            <div role="tabpanel" class="tab-pane" id="leisure">
                                            {
                                                this.renderBenefitCarousel({data: leisure, is_more_two: true})
                                            }
                                        </div>
                                        

                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div> 
                {/* Benefit section end */}
                <div class="contianer-fluid footer_container">
		            <img src={Footer} class="img-responsive" alt="Footer" />
	            </div>
           </div>
       )
    }

    renderBenefitCarousel =({data, is_more_two}) => {
        // console.log("data: ", data)
        var settings = {
            dots: false,
            infinite: true,
            speed: 500,
            slidesToShow: is_more_two ? 3:2,
            slidesToScroll: 1,
            initialSlide: 0,
            autoplay: true,
            responsive: [
              {
                breakpoint: 1024,
                settings: {
                  slidesToShow: 2,
                  slidesToScroll: 1,
                  infinite: true,
                  dots: false
                }
              },
              {
                breakpoint: 600,
                settings: {
                  slidesToShow: 2,
                  slidesToScroll: 1,
                  initialSlide: 2,
                  dots: false
                }
              },
              {
                breakpoint: 480,
                settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1,
                  dots: false
                }
              }
            ]
          };
        return(
            <Slider {...settings}>
                {
                    data.map( (benefit, index) => 
                        <div className="lp_benefits" key={index}>
                            <div className="lp_items">
                                <div className="lp_benefits_items">
                                    <h5>{benefit.name}</h5>
                                    <div className="lp_benefits_img">
                                        <img src={benefit.image} alt="Beauty-Angel" className="img-responsive"/>
                                    </div>
                                    <div className="lp_benefits_ben">
                                        <div className="lp_label">Benefits :</div>
                                        <div className="lp_label_content">{benefit.benefit}</div>
                                    </div>
                                    <div className="lp_benefits_inquiry">
                                        <div className="lp_label">Inquiry :</div>
                                        <div className="lp_label_content">{benefit.inquiry}</div>
                                    </div>
                                    <div className="lp_benefits_location">
                                        <div className="lp_label">Location :</div>
                                        <div className="lp_label_content">{benefit.location}</div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    )
                }
            </Slider>
        )
    }
}

export default Owner;